import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { payForPurchase, clearError, clearMessage } from "../redux/manageProductSlice";

const PayPurchaseModel = ({ visible, onCancel, status, paingamount }) => {
  const dispatch = useDispatch();
  const [amount, setAmount] = useState(0);
  const { loading, error, message } = useSelector((state) => state.manageProduct);

  const onConfirm = () => {
    if (!amount && status !== "cancel") {
      alert("Enter amount");
      return;
    }
    if (status == "cancel") {
      setAmount(0);
    }
    if (Number(amount) > paingamount()) {
      alert("Enter amount less than max");
      return;
    }

    const total_amount = paingamount();
    const payData = { amount, status, total_amount };
    dispatch(payForPurchase(payData));
    onCancel();
  };

  useEffect(() => {
    if (error) {
      alert(error);
      dispatch(clearError());
    }
    if (message) {
      alert(message);
      dispatch(clearMessage());
    }
  }, [error, message, dispatch]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 sm:w-96">
        <div className="mb-4">
          <h3 className="text-lg font-bold text-gray-900">
            {status === "full"
              ? `Amount you have to pay full amount of Rs ${paingamount()}`
              : status === "discount"
              ? `Amount you have to pay less than Rs ${paingamount()}`
              : "Are you sure you want to cancel the order?"}
          </h3>
        </div>
        {status !== "cancel" && (
          <div className="mb-4">
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Amount"
              className="w-full p-2 border rounded-lg"
            />
          </div>
        )}
        <div className="flex justify-between space-x-4">
          <button
            onClick={onCancel}
            className="flex-1 bg-gray-300 py-2 rounded-lg text-gray-700 text-sm"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 bg-green-500 py-2 rounded-lg text-white text-sm"
          >
            {loading ? "...Loading" : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayPurchaseModel;
